import styled from 'styled-components';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { TextColors, Fonts, Spacings } from '@styles/index';

const H5 = styled.h5`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H5};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  @media (max-width: 70.95em) {
    font-size: 14px;
  }
  @media (max-width: 47.95em) {
    font-size: 16px;
  }
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default H5;

H5.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H5.defaultProps = {
  color: TextColors.BLACK,
  lineClamp: null
};
